module.exports = __webpack_public_path__ + "69e80be4592f2c33580b4778bb2986a5.svg";